<!--
Desktop: apenas layout + classes da barra Shorts. Regras em composables genéricos.
-->
<script setup lang="ts">
import type { SearchSuggestSelectionBus } from '~/composables/useNewSearchSuggest';
import type { PropertyFilters } from '~/core/entities/property/filters';

import { useSearchSuggestGeoOnlyConfig } from '~/composables/searchSuggest/useSearchSuggestGeoOnlyConfig';
import { useSearchSuggestParentDrivenSelectionFieldConfig } from '~/composables/searchSuggest/useSearchSuggestParentDrivenSelectionFieldConfig';

import SearchSuggestField from '~/components/SearchSuggest/SearchSuggestField.vue';

const SHORTS_INPUT_PLACEHOLDER = 'Busque lugares';

const searchSuggestFieldBehaviour = {
	...useSearchSuggestGeoOnlyConfig(),
	...useSearchSuggestParentDrivenSelectionFieldConfig()
};

interface ShortsSearchSuggestInlineProps {
	searchTerm: string;
	locationLabel: string;
	cities: PropertyFilters['cities'];
	regions: PropertyFilters['regions'];
	macroregions: PropertyFilters['macroregions'];
	states: PropertyFilters['states'];
	currentFilters: PropertyFilters;
	bus: SearchSuggestSelectionBus;
	fieldClass?: string;
}

const props = withDefaults(defineProps<ShortsSearchSuggestInlineProps>(), {
	fieldClass: 'hidden w-full border-none md:block'
});

const emit = defineEmits<{
	'update:search-term': [value: string];
	emptyResultOnFilter: [searchTerm: string];
	clear: [];
}>();

const placeholders = computed(
	() => props.locationLabel?.trim() || SHORTS_INPUT_PLACEHOLDER
);
</script>

<template>
	<SearchSuggestField
		v-bind="searchSuggestFieldBehaviour"
		variant="dark"
		:search-term="searchTerm"
		:current-filters="currentFilters"
		:cities="cities"
		:regions="regions"
		:macroregions="macroregions"
		:states="states"
		:class="fieldClass"
		:placeholders="placeholders"
		:input-focused-placeholder="SHORTS_INPUT_PLACEHOLDER"
		:emit-empty-state-only-after-autocomplete="true"
		:include-text-searched-in-selection-payload="true"
		input-wrapper-classes="h-11 md:h-[50px] p-0 bg-primary-light-4 border border-primary-light-3"
		input-classes="h-full pr-3 pl-4 placeholder:opacity-100 focus:placeholder:opacity-100 bg-transparent text-white"
		input-search-icon-wrapper-classes="hidden"
		input-clear-icon-wrapper-classes="pr-3"
		input-clear-icon-classes="text-primary-light-1"
		list-wrapper-classes="absolute left-0 right-0 top-full z-50 mt-1 !h-auto max-h-[450px] w-full overflow-y-auto rounded-lg border-none bg-black shadow-lg"
		group-heading-classes="text-white"
		group-icon-classes="text-white-dark-4"
		group-item-wrapper-classes="data-highlighted:bg-primary-light-4"
		group-item-text-classes="text-white"
		group-item-sub-text-classes="text-white-dark-4"
		empty-state-title-classes="text-white"
		empty-state-description-classes="text-white-dark-4"
		:bus="bus"
		@update:search-term="emit('update:search-term', $event)"
		@empty-result-on-filter="emit('emptyResultOnFilter', $event)"
		@clear="emit('clear')"
	>
		<template #input-prefix>
			<slot name="input-prefix" />
		</template>
	</SearchSuggestField>
</template>
